<template>
    <app-layout>
        <app-header />
        <app-container />
        <app-footer />
        <app-drawer-navigation />
    </app-layout>
</template>
